export const VesselRoutes = {
    // AddToMyFleet: "MyFleet/AddToMyFleet",
    GetVesselApplicationFormCorrespondenceCount: "Vessel/GetVesselApplicationFormCorrespondenceCount",
    GetVessel: "Vessel/GetVessel",
    GetVesselApplicationFormIdFromGuid: "Vessel/GetVesselApplicationFormIdFromGuid",
    GetVesselAnonymously: "Vessel/GetVesselAnonymously",
    SaveDynamicPropertiesForEntity: "Vessel/SaveDynamicPropertiesForEntity",
    GetSafetySubscoreModel: "SafetyRating/GetSafetySubscoreModel",
    GetSafetyVesselSubscoreIncidentModel: "SafetyRating/GetSafetyVesselSubscoreIncidentModel",
    GetSafetyVesselSubscorePscInspectionModel: "SafetyRating/GetSafetyVesselSubscorePscInspectionModel",
    GetSafetyRating: "SafetyRating/GetSafetyRatingModel",
    GetSafetyScoreChange: "SafetyRating/GetSafetyScoreChangeModel",
    GetModelLastRun: "SafetyRating/GetModelLastRun",
    GetVesselBenchmark: "SafetyRating/GetVesselBenchmark",
    GetRatingsModel: "SafetyRating/GetRatingsModel",
    GetVesselActivitiesData: "Vessel/GetVesselActivitiesData",
    GetBanners: "Vessel/GetBanners",
    GetVesselPerformance: "Vessel/GetVesselPerformance",
    GetVesselHeader: "Vessel/GetVesselHeader",
    GetVesselGhgSummary: "Vessel/GetVesselGhgSummary",
    GetVesselOperationalMetrics: "Vessel/GetVesselOperationalMetrics",
    GetVesselGHGRatingPeerGroup: "Vessel/GetVesselGHGRatingPeerGroup",
    GetVesselCompanyRoles: "Vessel/GetVesselCompanyRoles",
    SaveVessel: "Vessel/SaveVessel",
    DeleteVessel: "Vessel/DeleteVessel",
    ReRunSystemRules: "Vessel/ReRunSystemRules",
    DownloadPdf: "Vessel/downloadPdf",
    DownloadExcel: "Vessel/downloadExcel",
    // GetMyFleetIds: "MyFleet/GetMyFleetIds",
    SendVesselForm: "Vessel/SendVesselForm",
    GetVesselCertificates: "Vessel/GetVesselCertificates",
    GetVesselSurveysAndCertificates: "Vessel/GetVesselSurveysAndCertificates",
    GetVesselUscgData: "Vessel/GetVesselUscgData",
    GetCAPSurvey: "Vessel/GetCAPSurvey",
    SaveCAPSurvey: "Vessel/SaveCAPSurvey",
    DeleteCAPSurvey: "Vessel/DeleteCAPSurvey",
    GetVesselThirdPartyInspections: "Vessel/GetVesselThirdPartyInspections",
    GetThirdPartyInspection: "Vessel/GetThirdPartyInspection",
    SaveThirdPartyInspection: "Vessel/SaveThirdPartyInspection",
    DeleteThirdPartyInspection: "Vessel/DeleteThirdPartyInspection",
    MatchVessels: "Vessel/MatchVessels",
    GetVesselMous: "Vessel/GetVesselMous",
    ClearVesselMou: "Vessel/ClearVesselMou",
    MarkUscgItemAsClosed: "Vessel/MarkUscgItemAsClosed",
    DownloadVesselDetailsAsExcel: "Vessel/DownloadVesselDetailsAsExcel",
    GetClassSocietiesHistories: "Vessel/GetClassSocietiesHistories",
    GetVesselTypesGHGRatingPeerGroup: "Vessel/GetVesselTypesGHGRatingPeerGroup",
    GetClassSurvey: "Vessel/GetClassSurvey",
    SaveClassSurvey: "Vessel/SaveClassSurvey",
    DeleteClassSurvey: "Vessel/DeleteClassSurvey",
    GetClassCertificate: "Vessel/GetClassCertificate",
    SaveClassCertificate: "Vessel/SaveClassCertificate",
    DeleteClassCertificate: "Vessel/DeleteClassCertificate",
    GetVesselDynamicProperties: "Vessel/GetVesselDynamicProperties",
    CanVesselBeVetted: "Vessel/CanVesselBeVetted",
    GetAffiliatedVessels: "Vessel/GetAffiliatedVessels",
    GetMaskDataForVessel: "Vessel/GetMaskDataForVessel",
    CloseGracePeriodBanner: "Vessel/CloseGracePeriodBanner",
    GetVesselsByCompanyId: "Vessel/GetVesselsByCompanyId",
    ExtractVesselsFromFile: "Vessel/ExtractVesselsFromFile"
}
